function hash32(input, seed) {
  let hash = seed >>> 0;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash.toString(16).padStart(8, '0');
}

export function deterministicMentionId({
  schoolId,
  issuedById,
  issuanceId,
} = {}) {
  if (!schoolId || !issuedById || !issuanceId) return null;
  const identity = `${schoolId}|${issuedById}|${issuanceId}`;
  return `mention_${hash32(identity, 0x811c9dc5)}${hash32(identity, 0x9e3779b9)}`;
}

export function createMentionIssuanceId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return `issue-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
